import React from "react";
import PropTypes from "prop-types";
import { Container, Row, Col } from "shards-react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const noLayout = ({ children, noNavbar, noFooter }) => (
  <Container fluid className="h-100">
    <ToastContainer />
    <Row className="h-100 pl-5 pr-5">
      <Col
        className="main-content p-0"
        lg={{ size: 12 }}
        md={{ size: 12 }}
        sm="12"
        tag="main"
      >
        {children}
      </Col>
    </Row>
  </Container>
);

noLayout.propTypes = {
  noNavbar: PropTypes.bool,
  noFooter: PropTypes.bool,
};

noLayout.defaultProps = {
  noNavbar: false,
  noFooter: false,
};

export default noLayout;
